import { LucideIcon } from 'lucide-react'
import { ReactElement } from 'react'

import { cn } from '../../lib/utils'
import { Button, ButtonProps } from '../ui'

interface IconButtonProps extends ButtonProps {
    icon: LucideIcon
    label?: string
}

export const ButtonWithIcon: React.FC<IconButtonProps> = ({
    icon: Icon,
    label,
    className,
    ...props
}): ReactElement => {
    return (
        <Button
            size={label ? 'default' : 'icon'}
            variant="outline"
            className={cn(
                'rounded-full border p-2',
                label && 'space-x-2 border-none rounded-md',
                className,
            )}
            {...props}
        >
            <Icon className="h-4 w-4" />
            <span>{label}</span>
        </Button>
    )
}
